import React, { useEffect, useState } from "react";
import API from "../../Network/API";
import ContentLoader from "react-content-loader"
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import EditMeeting from "../Modal/EditMeeting";
import { useTranslation } from "react-i18next";

export default function MeetingHistory() {
  const {t} = useTranslation()
  const [meetingList, setMeetingList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [demo_data, setDatas] = useState([{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }]);
  const [progress, setProgress] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [next_page, setNextPage] = useState('/my_meeting_history');
  const [nextPageUrl, setNextPageURL] = useState(null);
  const [lengthData, setDataLength] = useState(0);
  const [sc_meet, setScMeet] = useState(null);
    const [edit_modalDialog, setEditModalDialog] = useState(false);
    const [modalDialog, setModalDialog] = useState(false);

  const myArr = JSON.parse(localStorage.getItem('user_data'));
  useEffect(() => {
    fetchRepositories()
  }, []);

  function fetchRepositories() {

    setProgress(true)

    API.get(next_page, {
      'offset': meetingList.length
    }).then((response) => {

      const paginator = response.data.data;
      setDataLength(paginator.total)
      if (paginator.meeting_data.length) {
        setMeetingList(paginator.meeting_data)
        setProgress(false)
        setNextPageURL(paginator.next_page_url)
        setPage((page + 1))
      }

    }).catch((error) => {
      setProgress(true)

    });

  }

  const toggleEditMeeting = (meeting_room) => {
    setScMeet(meeting_room)
    setEditModalDialog(!modalDialog)
  };

  function fetchRepositoriesNext() {

    setLoading(true)

    API.get(next_page + '?page=' + page, {
      'offset': meetingList.length
    }).then((response) => {
      setLoading(false)
      const paginator = response.data.data;
      setDataLength(paginator.total)
      if (paginator.meeting_data.length) {
        setMeetingList([...meetingList, ...paginator.meeting_data])
        setNextPageURL(paginator.next_page_url)
        setPage((page + 1))
        setIsFetching(false)
      }
    }).catch((error) => {
      setLoading(false)
    });

  }

  // const meeting_delete = (m_id) => {
  //   var result = window.confirm("Are you sure want to delete?");
  //   if (result == true) {
  //     setLoading(true)
  //     API.delete("/meeting_delete/" + m_id).then((response) => {
  //       setLoading(false)
  //       if (response.data.success === true) {
  //         toast.success('delete successfully');
  //       }
  //     });
  //   }
    
  // }



  return (
    <>
      <div className="min-vh-100 bg-white">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-xl-7">
              <div className="d-flex align-items-center justify-content-between mb-4">
                <h2 className="fw-bold text-dark mb-0">{t('Meeting History')}</h2>
                <Link
                  to="/meeting"
                  className="btn btn-outline-dark rounded-pill px-3 py-1 d-flex align-items-center"
                  style={{ fontSize: '12px', fontWeight: '500' }}
                >
                  <i className="fa-solid fa-arrow-left me-1" style={{ fontSize: '11px' }}></i>
                  Back to Meetings
                </Link>
              </div>

              {progress && demo_data?.map((post, i) => (
                <div key={i} className="mb-2">
                  <ContentLoader
                    speed={2}
                    width="100%"
                    height={80}
                    viewBox="0 0 100 80"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                    className="rounded-2"
                  >
                    <rect x="8" y="15" rx="6" ry="6" width="10" height="10" />
                    <rect x="22" y="12" rx="3" ry="3" width="30" height="5" />
                    <rect x="22" y="20" rx="2" ry="2" width="40" height="3" />
                    <rect x="8" y="35" rx="3" ry="3" width="20" height="3" />
                    <circle cx="12" cy="50" r="3" />
                    <circle cx="20" cy="50" r="3" />
                    <circle cx="28" cy="50" r="3" />
                    <rect x="75" y="35" rx="3" ry="3" width="12" height="6" />
                  </ContentLoader>
                </div>
              ))}

              {!progress && meetingList?.map((meeting, index) => (
                <div key={index} className="mb-2">
                  <div className="bg-white border rounded-2 p-3 shadow-sm hover-shadow-md transition-all">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center flex-grow-1">
                        <div className="me-3 text-center">
                          <div className="bg-light rounded-2 px-2 py-1 d-flex flex-column align-items-center" style={{ minWidth: '55px' }}>
                            <div className="fw-bold text-dark" style={{ fontSize: '16px', lineHeight: '1' }}>
                              {new Date(meeting.created_at).getDate()}
                            </div>
                            <div className="text-muted" style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                              {new Date(meeting.created_at).toLocaleDateString('en-US', { month: 'short' })}
                            </div>
                            <div className="text-muted fw-medium" style={{ fontSize: '10px' }}>
                              {new Date(meeting.created_at).getFullYear()}
                            </div>
                          </div>
                        </div>

                        <div className="flex-grow-1 min-w-0">
                          <div className="d-flex align-items-center mb-1">
                            <h6 className="fw-semibold text-dark mb-0 me-2" style={{ fontSize: '15px' }}>
                              {meeting.room_title}
                            </h6>
                            <span 
                              className="badge bg-success bg-opacity-10 text-success rounded-pill px-2 py-1 d-flex align-items-center"
                              style={{ fontSize: '9px', fontWeight: '500' }}
                              title="Completed meeting"
                            >
                              <i className="fa-solid fa-check me-1" style={{ fontSize: '8px' }}></i>
                              Completed
                            </span>
                          </div>

                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <div className="d-flex me-2">
                                {meeting.room_history.slice(0, 3).map((user, userIndex) => (
                                  <Link key={userIndex} to={`/contact/${user.id}`} className="me-1">
                                    <div
                                      className="rounded-circle border border-white shadow-sm"
                                      style={{
                                        width: '26px',
                                        height: '26px',
                                        backgroundImage: `url(${user.avatar})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        marginLeft: userIndex > 0 ? '-6px' : '0'
                                      }}
                                    />
                                  </Link>
                                ))}
                                {meeting.room_history.length > 3 && (
                                  <Link to={`/meeting-details/${meeting.room_name}`}>
                                    <div
                                      className="rounded-circle bg-light border border-white shadow-sm d-flex align-items-center justify-content-center text-muted fw-medium"
                                      style={{
                                        width: '26px',
                                        height: '26px',
                                        fontSize: '9px',
                                        marginLeft: '-6px'
                                      }}
                                    >
                                      +{meeting.room_history.length - 3}
                                    </div>
                                  </Link>
                                )}
                              </div>

                              <div className="d-flex gap-1">
                                <a
                                  href={`https://connectsapp.com/meeting/${meeting.room_name}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-light btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                  style={{ width: '26px', height: '26px' }}
                                  title="Start again"
                                >
                                  <i className="fa-solid fa-play text-muted" style={{ fontSize: '10px' }}></i>
                                </a>
                                <button
                                  onClick={() => toggleEditMeeting(meeting)}
                                  className="btn btn-light btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                  style={{ width: '26px', height: '26px' }}
                                  title="Edit meeting"
                                >
                                  <i className="fa-solid fa-edit text-muted" style={{ fontSize: '10px' }}></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="ms-2">
                        <Link to={`/meeting-details/${meeting.room_name}`}>
                          <button className="btn btn-outline-dark rounded-pill px-3 py-1" style={{ fontSize: '12px', fontWeight: '500' }}>
                            <i className="fa-solid fa-arrow-right me-1" style={{ fontSize: '10px' }}></i>
                            {t('Details')}
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {nextPageUrl != null && (
                <div className="text-center mt-4">
                  <button 
                    className="btn btn-outline-dark rounded-pill px-5 py-3 border-2"
                    onClick={fetchRepositoriesNext}
                    disabled={isLoading}
                    style={{ fontSize: '14px', fontWeight: '500' }}
                  >
                    {isLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                          style={{ width: '16px', height: '16px' }}
                        ></span>
                        Loading...
                      </>
                    ) : (
                      <>
                        <i className="fa-solid fa-plus me-2" style={{ fontSize: '12px' }}></i>
                        Load More
                      </>
                    )}
                  </button>
                </div>
              )}

              {meetingList.length === 0 && !progress && (
                <div className="text-center py-4 mt-4">
                  <div className="mb-3">
                    <i className="fa-solid fa-clock-rotate-left text-muted" style={{ fontSize: '36px' }}></i>
                  </div>
                  <h5 className="fw-bold text-dark mb-2">No meeting history</h5>
                  <p className="text-muted mb-3" style={{ fontSize: '14px' }}>Your completed meetings will appear here</p>
                  <Link to="/meeting">
                    <button
                      className="btn btn-dark rounded-pill px-3 py-2"
                      style={{ fontSize: '13px', fontWeight: '500' }}
                    >
                      <i className="fa-solid fa-calendar-plus me-2" style={{ fontSize: '11px' }}></i>
                      Schedule Meeting
                    </button>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <EditMeeting isModalVisible={edit_modalDialog} meetingRoom={sc_meet} handleShowB={() => setEditModalDialog(false)}/>
    </>
  )
}